import { CSSTransition } from 'react-transition-group';
import { LinkId } from '../../../../AnalyticsContext/LinkId';
import { applyTrackingId } from '../../../../AnalyticsContext/applyTrackingId';
import { IdentityProvider } from '../../../../UserProvider/UserData';
import { useCTA } from '../../../../hooks/useCTA';
import { CTADot, LinkContent } from '../../../CTADot';
import { Divider, Icon, LogoutLink, Menu, MenuLink, UserMenuView } from './UserMenu.styles';

interface Props {
  identityProvider?: IdentityProvider;
  showing?: boolean;
  onClickLink?: VoidFunction;
  onClickLogout?: VoidFunction;
}

export const UserMenu = ({
  identityProvider = IdentityProvider.HEALTHENGINE,
  onClickLink,
  onClickLogout,
  showing = false,
}: Props) => {
  const { cta } = useCTA();

  return (
    <CSSTransition unmountOnExit in={showing} timeout={300}>
      <UserMenuView>
        <Menu>
          {identityProvider === IdentityProvider.HEALTHENGINE && (
            <>
              <MenuLink
                onClick={onClickLink}
                to="/my-account/profiles"
                trackingId={LinkId.HEADER_LOGGED_IN_PROFILES}
              >
                Profiles
              </MenuLink>

              <MenuLink
                onClick={onClickLink}
                to={`/my-account/health-interests${
                  cta?.showHealthInterestsCTA ? '?icid=nd::hea:::all:hei:::jun22' : ''
                }`}
                trackingId={LinkId.HEADER_LOGGED_IN_HEALTH_INTERESTS}
                data-notify-dot={Boolean(cta?.showHealthInterestsCTA)}
              >
                <LinkContent>
                  My interests
                  {cta?.showHealthInterestsCTA && <CTADot />}
                </LinkContent>
              </MenuLink>

              <MenuLink
                onClick={onClickLink}
                to="/my-account/offers?icid=nd:avs:hea:lap:med:all:ctb:::jul22"
                trackingId={LinkId.HEADER_LOGGED_IN_OFFERS}
                data-notify-dot={Boolean(cta?.showNewOfferAddedCTA)}
              >
                <LinkContent>
                  My offers
                  {cta?.showNewOfferAddedCTA && <CTADot />}
                </LinkContent>
              </MenuLink>

              <MenuLink
                onClick={onClickLink}
                to="/my-account/data-privacy"
                trackingId={LinkId.HEADER_LOGGED_IN_PRIVACY}
              >
                <LinkContent>
                  Data & privacy
                  {cta?.showPrivacyPreferencesCTA && <CTADot />}
                </LinkContent>
              </MenuLink>

              <MenuLink
                onClick={onClickLink}
                to="https://login.healthengine.com.au/password/change"
                trackingId={LinkId.HEADER_CHANGE_MY_PASSWORD}
              >
                Change my password
              </MenuLink>

              <Divider />
            </>
          )}
          <LogoutLink
            onClick={onClickLogout}
            {...applyTrackingId(
              identityProvider === IdentityProvider.HEALTHENGINE
                ? LinkId.HEADER_LOG_OUT
                : LinkId.HEADER_CORPORATE_GROUP_IDENTITY_LOG_OUT,
            )}
          >
            Logout
            <Icon />
          </LogoutLink>
        </Menu>
      </UserMenuView>
    </CSSTransition>
  );
};
